module.exports = ".questions-lists {\n  padding-left: 15px;\n}\n\n.pointer {\n\tcursor: pointer;\n}\n"